<template>
  <div id="outer_game_home_outer" v-if="dataInited" class="vue_body_min_height" style="padding-bottom: 50px;">
    <img v-if="currentBanner != null" :src="currentBanner.url" style="width: 100%;">
    <div class="container" style="text-align: center">
      <div v-if="match != null" id="detail_top_title">{{match.title}}</div>
      <div v-if="match != null" id="detail_top_desc">{{match.subtitle}}</div>
    </div>

    <div id="match_list_sub_menus" class="container">
      <a href="javascript:void(null);"
         v-for="(item, index) in subList"
         :class="tabIndex == index ? 'active' : ''"
         @click="subMenuClicked(index)"
         :key="'match_list_menu_' + index"><span class="iconfont" style="margin-right: 10px;">{{item.iconText}}</span>{{item.title}}</a>
    </div>

    <div class="container" v-if="showAsHomePage">
      <outer-games-list v-if="tabIndex == 0"></outer-games-list>
      <games-rank-page v-else-if="tabIndex == 1"></games-rank-page>
      <game-teams-list-page v-else-if="tabIndex == 2" ></game-teams-list-page>
      <match-detail-news v-else-if="tabIndex == 3" v-bind:tag-name="match.title"></match-detail-news>
    </div>

    <div id="sub_page_outer" class="container" v-else>
      <outer-game-detail v-if="tabIndex == 0"></outer-game-detail>
      <game-team-detail-page v-else-if="tabIndex == 2"></game-team-detail-page>
    </div>

    <login-dialog v-if="showLogin" v-on:close="closeLoginDialog"></login-dialog>
  </div>
</template>

<script>
  import GameHttpManager from '../../js/outer-games-http-define';
  import MatchDetailNews from "../../components/matches/MatchDetailNews";
  import OuterGamesList from "./OuterGamesList";
  import OuterGameDetail from "./OuterGameDetail";
  import GamesRankPage from "./GamesRankPage";
  import GameTeamsListPage from "./GameTeamsListPage";
  import GameTeamDetailPage from "./GameTeamDetailPage";
  import LoginDialog from "../../components/common/LoginDialog";
export default {
  name: "OuterGameHome",
  components: {
    OuterGameDetail,
    MatchDetailNews,
    OuterGamesList,
    GamesRankPage,
    GameTeamsListPage,
    GameTeamDetailPage,
    LoginDialog
  },
  data() {
    return {
      item: {
        title: '上海市中小学冠军赛',
        subtitle: '比赛日期：2021年5月20日-2021年5月31日'
      },
      match: null,
      subList: [],
      addActivities: false,
      tabIndex: 0,
      showAsHomePage: true,
      dataInited: false,
      showLogin: false,
      intervalFlag: null,
      secondValue: 20,
      isLogined: true,
    }
  },
  computed: {
    dataManager() {
      return this.$store.state.dataStore;
    },
    httpManager() {
      return this.$store.state.http;
    },
    id() {
      return this.$route.params.id;
    },
    banners() {
      return this.$store.state.banners;
    },
    currentBanner() {
      if (this.banners == null) {
        return null;
      }
      let item = this.banners.find(function (item) {
        return  item.name == 'matches';
      });

      if (item == undefined) {
        return null;
      }
      return item;
    },
  },
  destroyed() {
    if (this.intervalFlag != null) {
      clearTimeout(this.intervalFlag);
      this.intervalFlag = null;
    }
  },

  mounted() {
    this.initData();
  },

  methods: {
    closeLoginDialog() {
      let token = this.dataManager.getToken();
      if (token != null) {
        this.isLogined = true;
      }
      this.showLogin = false;
      // this.dealWithInterval();
    },

    checkNeedsLogin() {
      let _this = this;
      this.checkToken(this.$store,function (data) {
        let code = data.code;
        _this.isLogined = code == 0;
        _this.dealWithInterval();
      });
    },
    dealWithInterval() {
      if (!this.isLogined) {
        let timerInterval = this.secondValue * 1000;
        this.intervalFlag = setTimeout(this.showLoginPage, timerInterval);
      }
    },

    showLoginPage() {
      let showed = this.$store.state.dataStore.showLoginDialog();
      if (!showed) {
        this.intervalFlag = null;
        return;
      }
      this.showLogin = true;
      this.intervalFlag = null;
    },

    initData() {
      let query = this.$route.query;
      let sub = query.sub;
      let index = query.index;
      if (index != undefined && index > 0 & index < 5) {
        this.tabIndex = index - 1;
      }

      if (sub != undefined) {
        if (sub == 1) {
          this.showAsHomePage = false;
        }
      }


      this.loadData();
      this.dataInited = true;

      let state = query.state;
      if (state != undefined) {
        this.showLogin = true;
        return;
      }
      this.checkNeedsLogin();
    },

    subMenuClicked(index) {
      this.tabIndex = index;
      this.$router.push({
        name: 'matchGamesHomePage',
        params: {
          id: this.id
        },
        query: {
          index: index + 1,
        }
      });
      this.$router.go(0);
    },

    dealWithShareObj() {
      let shareObj = this.$store.state.http.defaultShareObj;
      shareObj.title = this.match.title;
      shareObj.link = location.href;
      this.configShareWx(encodeURIComponent(location.href), shareObj);
    },

    loadData() {
      let id= this.id;
      if (id == undefined) {
        return;
      }
      let _this = this;
      this.httpManager.ajax.vmMatchGet(id, function (data) {
        let code = data.code;
        if (code == 0) {
          _this.match = data.data;
          _this.loadActivitiesData();
          _this.dealWithShareObj();
          return;
        }
        _this.$toast('请求失败！');
      }, function (data) {
        _this.$toast('请求失败，请重试！');
      })
    },
    loadActivitiesData() {
      if (this.match == null) {
        return;
      }
      let tag = ((this.match.title == undefined || this.match.title == null) ? '' : this.match.title).removeBlanks();
      let params = {
        pageIndex: 1,
        size: 1,
        tag: tag,
      };
      let _this = this;
      this.httpManager.ajax.matchDeatilList(params,function (data) {
        let code = data.code;
        if (code == 0) {
          let newList = data.data;
          if (newList.length > 0) {
            _this.addActivities = true;
          }
          _this.dealWithTabs();
          return;
        }
        _this.dealWithTabs();
      },function (data) {
        _this.dealWithTabs();
      });
    },
    dealWithTabs() {
      let list = [];

      list.push({
        title: '赛程表',
        iconText: '\ue62c',
      });
      list.push({
        title: '数据排行',
        iconText: '\ue65d',
      });
      list.push({
        title: '参赛球队',
        iconText: '\ue60e',
      });

      if (this.addActivities) {
        list.push({
          title: '动态',
          iconText: '\ue610',
        });
      }
      this.subList = list;
    },
  }
}
</script>

<style scoped>

  #outer_game_home_outer {

  }

  #detail_top_title {
    font-size: 1.5rem;
    font-weight: bold;
    color: #333;
    margin-top: 40px;
  }

  #detail_top_desc {
    font-size: 1rem;
    color: #999;
    margin-top: 10px;
  }

  #match_list_sub_menus {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    flex-wrap: wrap;
    width: 100%;
  }

  @media screen and (min-width: 768px) {
    #match_list_sub_menus {
      justify-content: space-around;

    }
  }

  #match_list_sub_menus > a {
    color: #333;
    text-decoration: none;
    font-weight: bold;
    font-size: 1.2rem;
    width: 100px;
    display: block;
    text-align: left;
    margin-top: 15px;
    margin-left: 15px;
  }

  #match_list_sub_menus > a.active {
    color: #fc1a34;
    pointer-events: none;
  }

  #outer_game_home_outer #sub_page_outer {
    box-shadow: 0 0 15px rgba(255,0,0, 0.15);
    padding: 20px 15px;
    margin-top: 30px;
  }

  @media screen and (min-width: 768px) {
    #outer_game_home_outer #sub_page_outer {
      padding: 40px 30px;
    }

  }

</style>



// WEBPACK FOOTER //
// src/pages/outer-matches/OuterGameHome.vue